<template>
    <div >
        <div class="simple__block" v-if="template==='orders'">
            <h3 class="h5">{{ get_translation_constant('text_attached_files') }}</h3>
            <table class="table table__files">
                <thead>
                <tr>
                    <th>{{ get_translation_constant('text_file_format') }}</th>
                    <th>{{ get_translation_constant('text_file_name') }}</th>
                    <th>{{ get_translation_constant('text_size') }}</th>
                    <th></th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(file, idx) in filesFromServer">
                    <td>
                        <div class="file" :class="getServerFileExtension(file)">
                            {{ getServerFileExtension(file).toUpperCase() }}
                        </div>
                    </td>
                    <td>
                        <a href="javascript:void(0)"
                           @click.prevent="downloadServerFileFile(file)">{{ getServerFileName(file) }}</a>
                        <div class="file-size d-lg-none">{{ getServerFileSize(file) }}</div>
                    </td>
                    <td>{{ getServerFileSize(file) }}</td>
                    <td>
                        <div class="table__actions d-flex justify-content-end">
                            <a href="javascript:void(0)" title="Remove" @click.prevent="removeServerFile(idx)">
                                <svg width="20" height="20" viewBox="0 0 20 20" fill="none"
                                     xmlns="http://www.w3.org/2000/svg">
                                    <path
                                        d="M15.2 16.31l.52-10.47h.73c.3 0 .55-.24.55-.53 0-.3-.24-.55-.55-.55h-3.22V3.7c0-1.02-.72-1.69-1.86-1.69H8.61c-1.14 0-1.84.67-1.84 1.69v1.07H3.55c-.3 0-.55.25-.55.55 0 .3.26.53.55.53h.74l.51 10.48c.05 1.03.75 1.68 1.82 1.68h6.77c1.06 0 1.76-.66 1.82-1.69zM7.96 3.76c0-.4.3-.7.75-.7h2.6c.44 0 .75.3.75.7v1h-4.1v-1zM6.73 16.93a.75.75 0 01-.77-.73L5.44 5.84h9.1l-.5 10.36a.74.74 0 01-.76.73H6.73zm5.46-1.26c.25 0 .43-.2.44-.47l.22-7.56c0-.27-.18-.47-.44-.47-.22 0-.42.2-.42.46l-.23 7.57c0 .26.18.47.43.47zm-4.38 0c.26 0 .44-.21.43-.47l-.22-7.57c0-.25-.2-.46-.43-.46-.26 0-.44.2-.43.47l.23 7.56c0 .27.18.47.42.47zm2.64-.47V7.63c0-.25-.2-.46-.44-.46-.25 0-.45.2-.45.46v7.57c0 .26.2.47.45.47.23 0 .44-.21.44-.47z"
                                        fill="#515154"/>
                                </svg>
                            </a>
                        </div>
                    </td>
                </tr>
                <tr v-for="(file, idx) in files">
                    <td>
                        <div class="file" :class="getExtension(file)">{{ getExtension(file).toUpperCase() }}</div>
                    </td>
                    <td>
                        <a href="javascript:void(0)" @click.prevent="downloadFile(file)">{{ getName(file) }}</a>
                        <div class="file-size d-lg-none">{{ getSize(file) }}</div>
                    </td>
                    <td>{{ getSize(file) }}</td>
                    <td>
                        <div class="table__actions d-flex justify-content-end">
                            <a href="javascript:void(0)" title="Remove" @click.prevent="remove(idx)">
                                <svg width="20" height="20" viewBox="0 0 20 20" fill="none"
                                     xmlns="http://www.w3.org/2000/svg">
                                    <path
                                        d="M15.2 16.31l.52-10.47h.73c.3 0 .55-.24.55-.53 0-.3-.24-.55-.55-.55h-3.22V3.7c0-1.02-.72-1.69-1.86-1.69H8.61c-1.14 0-1.84.67-1.84 1.69v1.07H3.55c-.3 0-.55.25-.55.55 0 .3.26.53.55.53h.74l.51 10.48c.05 1.03.75 1.68 1.82 1.68h6.77c1.06 0 1.76-.66 1.82-1.69zM7.96 3.76c0-.4.3-.7.75-.7h2.6c.44 0 .75.3.75.7v1h-4.1v-1zM6.73 16.93a.75.75 0 01-.77-.73L5.44 5.84h9.1l-.5 10.36a.74.74 0 01-.76.73H6.73zm5.46-1.26c.25 0 .43-.2.44-.47l.22-7.56c0-.27-.18-.47-.44-.47-.22 0-.42.2-.42.46l-.23 7.57c0 .26.18.47.43.47zm-4.38 0c.26 0 .44-.21.43-.47l-.22-7.57c0-.25-.2-.46-.43-.46-.26 0-.44.2-.43.47l.23 7.56c0 .27.18.47.42.47zm2.64-.47V7.63c0-.25-.2-.46-.44-.46-.25 0-.45.2-.45.46v7.57c0 .26.2.47.45.47.23 0 .44-.21.44-.47z"
                                        fill="#515154"/>
                                </svg>
                            </a>
                        </div>
                    </td>
                </tr>
                </tbody>
            </table>

            <div class="d-md-flex justify-content-end">
                <a class="btn btn__large btn__blue_border d-block"
                   @click="$refs.input.click()">{{ get_translation_constant('text_add_file') }}</a>

                <input v-if="multiple"
                       type="file"
                       ref="input"
                       :multiple="multiple"
                       @input="updateFiles"
                       @click="checkFiles"
                       :placeholder="get_translation_constant('text_add_file')"
                       style="display:none;"
                />

            </div>
        </div>

        <div class="simple__block block-upload-files" v-if="template==='arrived'">
<!--            <div class="d-md-flex">-->
                <a class="btn btn__large btn__blue_border d-block input-upload"
                   @click="$refs.input.click()">
                    <span>{{ get_translation_constant('text_upload_payment_confirmation_files') }}</span>
                    <span class="file-extension" v-html="allowedMimeTypeList"></span>
                </a>
                <input v-if="multiple"
                       type="file"
                       ref="input"
                       :multiple="multiple"
                       @input="updateFiles"
                       @click="checkFiles"
                       :placeholder="get_translation_constant('text_add_file')"
                       style="display:none;"
                />
<!--            </div>-->
            <table class="table table__files">
                <tbody>
                <tr v-for="(file, idx) in filesFromServer">
                    <td>
                        <div class="file" :class="getServerFileExtension(file)">
                            {{ getServerFileExtension(file).toUpperCase() }}
                        </div>
                    </td>
                    <td>
                        <a href="javascript:void(0)"
                           @click.prevent="downloadServerFileFile(file)">{{ getServerFileName(file) }}</a>
                        <div class="file-size d-lg-none">{{ getServerFileSize(file) }}</div>
                    </td>
                    <td>{{ getServerFileSize(file) }}</td>
                    <td>
                        <div class="table__actions d-flex justify-content-end">
                            <a href="javascript:void(0)" title="Remove" @click.prevent="removeServerFile(idx)">
                                <svg width="20" height="20" viewBox="0 0 20 20" fill="none"
                                     xmlns="http://www.w3.org/2000/svg">
                                    <path
                                        d="M15.2 16.31l.52-10.47h.73c.3 0 .55-.24.55-.53 0-.3-.24-.55-.55-.55h-3.22V3.7c0-1.02-.72-1.69-1.86-1.69H8.61c-1.14 0-1.84.67-1.84 1.69v1.07H3.55c-.3 0-.55.25-.55.55 0 .3.26.53.55.53h.74l.51 10.48c.05 1.03.75 1.68 1.82 1.68h6.77c1.06 0 1.76-.66 1.82-1.69zM7.96 3.76c0-.4.3-.7.75-.7h2.6c.44 0 .75.3.75.7v1h-4.1v-1zM6.73 16.93a.75.75 0 01-.77-.73L5.44 5.84h9.1l-.5 10.36a.74.74 0 01-.76.73H6.73zm5.46-1.26c.25 0 .43-.2.44-.47l.22-7.56c0-.27-.18-.47-.44-.47-.22 0-.42.2-.42.46l-.23 7.57c0 .26.18.47.43.47zm-4.38 0c.26 0 .44-.21.43-.47l-.22-7.57c0-.25-.2-.46-.43-.46-.26 0-.44.2-.43.47l.23 7.56c0 .27.18.47.42.47zm2.64-.47V7.63c0-.25-.2-.46-.44-.46-.25 0-.45.2-.45.46v7.57c0 .26.2.47.45.47.23 0 .44-.21.44-.47z"
                                        fill="#515154"/>
                                </svg>
                            </a>
                        </div>
                    </td>
                </tr>
                <tr v-for="(file, idx) in files">
                    <td>
                        <div class="file" :class="getExtension(file)">{{ getExtension(file).toUpperCase() }}</div>
                    </td>
                    <td>
                        <a href="javascript:void(0)" @click.prevent="downloadFile(file)">{{ getName(file) }}</a>
                        <div class="file-size d-lg-none">{{ getSize(file) }}</div>
                    </td>
                    <td>{{ getSize(file) }}</td>
                    <td>
                        <div class="table__actions d-flex justify-content-end">
                            <a href="javascript:void(0)" title="Remove" @click.prevent="remove(idx)">
                                <svg width="20" height="20" viewBox="0 0 20 20" fill="none"
                                     xmlns="http://www.w3.org/2000/svg">
                                    <path
                                        d="M15.2 16.31l.52-10.47h.73c.3 0 .55-.24.55-.53 0-.3-.24-.55-.55-.55h-3.22V3.7c0-1.02-.72-1.69-1.86-1.69H8.61c-1.14 0-1.84.67-1.84 1.69v1.07H3.55c-.3 0-.55.25-.55.55 0 .3.26.53.55.53h.74l.51 10.48c.05 1.03.75 1.68 1.82 1.68h6.77c1.06 0 1.76-.66 1.82-1.69zM7.96 3.76c0-.4.3-.7.75-.7h2.6c.44 0 .75.3.75.7v1h-4.1v-1zM6.73 16.93a.75.75 0 01-.77-.73L5.44 5.84h9.1l-.5 10.36a.74.74 0 01-.76.73H6.73zm5.46-1.26c.25 0 .43-.2.44-.47l.22-7.56c0-.27-.18-.47-.44-.47-.22 0-.42.2-.42.46l-.23 7.57c0 .26.18.47.43.47zm-4.38 0c.26 0 .44-.21.43-.47l-.22-7.57c0-.25-.2-.46-.43-.46-.26 0-.44.2-.43.47l.23 7.56c0 .27.18.47.42.47zm2.64-.47V7.63c0-.25-.2-.46-.44-.46-.25 0-.45.2-.45.46v7.57c0 .26.2.47.45.47.23 0 .44-.21.44-.47z"
                                        fill="#515154"/>
                                </svg>
                            </a>
                        </div>
                    </td>
                </tr>
                </tbody>
            </table>
        </div>

        <div class="simple__block" v-if="(template==='preview-photo') && filesFromServer.length">
            <h3 class="h5">{{ get_translation_constant('text_preview_service_pictures') }}</h3>
            <table class="table table__files">
                <thead>
                <tr>
                    <th>{{ get_translation_constant('text_file_format') }}</th>
                    <th>{{ get_translation_constant('text_file_name') }}</th>
                    <th>{{ get_translation_constant('text_size') }}</th>
                    <th></th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(file, idx) in filesFromServer">
                    <td>
                        <div class="file" :class="getServerFileExtension(file)">
                            {{ getServerFileExtension(file).toUpperCase() }}
                        </div>
                    </td>
                    <td>
                        <a href="javascript:void(0)"
                           @click.prevent="downloadServerFileFile(file)">{{ getServerFileName(file) }}</a>
                        <div class="file-size d-lg-none">{{ getServerFileSize(file) }}</div>
                    </td>
                    <td>{{ getServerFileSize(file) }}</td>
                    <td>

                    </td>
                </tr>
                </tbody>
            </table>
        </div>
    </div>

</template>

<script>
export default {
    name: 'FileUpload',
    data: function () {
        return {
            files: [],
            filesFromServer: [],
            allowedMimeTypes: [
                'image/png',
                'image/jpg',
                'image/jpeg',
                'image/gif',
                'application/pdf',
                'application/vnd.ms-excel',
                'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
                'application/zip',
                'application/x-zip',
                'application/x-zip-compressed'

            ]
        }
    },
    props: {
        multiple: {
            type: Boolean,
            default: () => false,
        },
        files_array: {
            type: Array,
            default: null,
        },
        translations: {
            type: [Object, Array]
        },
        ajax: {
            type: Boolean,
            default: () => false,
        },
        lng: {
            type: [String]
        },
        upload_files_link: {
            type: [String]
        },
        delete_files_link: {
            type: [String]
        },
        additional_ajax_params: {
            type: [String, Object, Number, Array]
        },
        downloadlink: {
            type: [String]
        },
        template: {
            type: [String],
            default: 'orders'
        },
    },

    created() {
        if (this.files_array !== null) {
            this.filesFromServer = this.files_array;
        }
    },

    methods: {
        downloadServerFileFile(file) {
            let fileToSend = {
                file_id: file.id,
                mimeType: this.getServerFileExtension(file),
                file_name: this.getServerFileName(file)
            }
            let formData = {
                ...fileToSend,
                ...this.additional_ajax_params
            }
            axios.post(this.downloadlink, formData, {
                responseType: 'blob',
            }).then(response => {
                let fileURL = window.URL.createObjectURL(new Blob([response.data]));
                let fileLink = document.createElement('a');

                fileLink.href = fileURL;
                fileLink.setAttribute('download', this.getServerFileName(file));
                document.body.appendChild(fileLink);

                fileLink.click();
                document.body.removeChild(fileLink);
            }).catch(error => {

                /*
                if (error.response.status === 400) {
                    console.log(response.data)
                }
                if (error.response.status === 422) {
                    console.log(response.data)
                }
                if (error.response.status === 500) {
                    console.log(response.data)
                }

                 */
            });
        },
        get_translation_constant(key) {
            return this.translations.filter((item) => {
                return item.key === key
            })[0]['value'][this.lng]
        },
        getName(file) {
            return file?.name;
        },
        updateFiles(e) {
            let accepted_files = Object.values(e.target.files).filter((file) => {
                // can add filesize validation
                return this.allowedMimeTypes.includes(file.type) /*&&
                    (typeof this.files.find((item) => {
                    return (item.name === file.name) && (item.type === file.type)
                }) === 'undefined')

                 */
            })

            let not_accepted = Object.values(e.target.files).filter((file) => {
                return !this.allowedMimeTypes.includes(file.type)
            })

            if (not_accepted.length) {
                this.$emit('childToParentAlert', not_accepted.map((file) => {
                    return file.name
                }))
            }
            if (!accepted_files.length) {
                return false;
            }
            let dt = new DataTransfer();
            for (let key in accepted_files) {
                dt.items.add(accepted_files[key])
            }
            e.target.files = dt.files;

            if (this.ajax) {
                this.sendFiles(e.target.files)
                //return if ajax!!!
                return true;
            }
            this.files = [...this.files, ...accepted_files];
            //handle in parent form
            this.$emit('childToParent', this.files)
        },
        remove(idx) {
            this.files.splice(idx, 1);
        },
        checkFiles(e) {
            if (!this.files.length) {
                e.target.value = null
            }
        },
        getSize(file) {
            return this.formatBytes(file.size)
        },
        downloadFile(file) {

        },
        getExtension(file) {
            if (!this.allowedMimeTypes.includes(file.type)) {
                return 'unrecognized';
            }
            switch (file.type) {
                case 'image/png':
                    return 'png';
                case 'image/jpg':
                    return 'jpg';
                case 'image/jpeg':
                    return 'jpg';
                case 'image/gif':
                    return 'gif';
                case 'application/pdf':
                    return 'pdf';
                case 'application/vnd.ms-excel':
                    return 'xls';
                case 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet':
                    return 'xlsx';
                case 'application/vnd.openxmlformats-officedocument.wordprocessingml.document':
                    return 'docx';
                case 'application/zip':
                    return 'zip';
                case 'application/x-zip':
                    return 'zip';
                case 'application/x-zip-compressed':
                    return 'zip';

            }
        },
        formatBytes(bytes, decimals = 2) {
            if (bytes === 0) return '0 Bytes';
            const k = 1024;
            const dm = decimals < 0 ? 0 : decimals;
            const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
            const i = Math.floor(Math.log(bytes) / Math.log(k));
            return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
        },
        getServerFileName(file) {
            return file?.file_original_name;
        },
        getServerFileExtension(file) {
            return file?.file_extension;
        },
        getServerFileSize(file) {
            return this.formatBytes(file?.file_size)
        },
        removeServerFile(idx) {
            console.log(idx, this.filesFromServer)
            let fileToSend = {
                file_id: this.filesFromServer[idx].id
            }
            let formData = {
                ...fileToSend,
                ...this.additional_ajax_params
            }
            axios.post(this.delete_files_link,
                formData, {}).then(response => {
                if (response.status === 200) {
                    //   console.log(response.data)
                    this.filesFromServer.splice(idx, 1);
                }
            }).catch(error => {
                //  console.log(error)
                this.$emit('childToParentAlert', [this.filesFromServer[idx]].map((file) => {
                    return file.file_name;
                }))
                /*
                if (error.response.status === 400) {
                    console.log(response.data)
                }
                if (error.response.status === 422) {
                    console.log(response.data)
                }
                if (error.response.status === 500) {
                    console.log(response.data)
                }
                 */
            });
        },
        sendFiles(files) {
            let formData = new FormData();
            for (let key = 0; key < this.$refs.input.files.length; key++) {
                formData.append('files[' + key + ']', this.$refs.input.files[key]);
            }
            for (let key in this.additional_ajax_params) {
                formData.append(key, this.additional_ajax_params[key]);
            }
            axios.post(this.upload_files_link,
                formData, {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                }).then(response => {
                if (response.status === 200) {
                    //    console.log(response.data)
                    this.filesFromServer = [...this.filesFromServer, ...response.data.accepted];
                    if (response.data.not_accepted.length) {
                        this.$emit('childToParentAlert', response.data.not_accepted.map((file) => {
                            return file.file_name;
                        }))
                    }

                }
            }).catch(error => {
                //  console.log(error)
                /*
                if (error.response.status === 400) {
                    console.log(response.data)
                }
                if (error.response.status === 422) {
                    console.log(response.data)
                }
                if (error.response.status === 500) {
                    console.log(response.data)
                }

                 */
            });
        },
        clearFiles(){
            this.files = [];
        },
        setServerFiles(files){
            this.filesFromServer = [...files];
        }
    },
    computed: {
        allowedMimeTypeList() {
            let allowedTypes = this.allowedMimeTypes.map((item) => {
                return this.getExtension({type: item})
            })
            return '(' + [...new Set(allowedTypes)].join(', ') + ')';
        }
    }
}
</script>

<style scoped>

</style>
